import { Coordinates } from 'components/Home/NearestStore/types';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { storesApiService } from 'api/stores.api.service';

export const getNearestStore = createAsyncThunk(
  'nearest-store/get',
  (coordinates: Coordinates) => storesApiService.getNearestStore(coordinates),
);
